export default __webpack_public_path__ + "6ffc05c2e604b47ac85446cd51442230.svg";